var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNrNauru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_21549)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4951 0H-22.5049V45H67.4951V0Z",
    fill: "#002170"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4951 20.5752H-22.5049V24.4336H67.4951V20.5752Z",
    fill: "#FFB20D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9697 38.4961L43.8701 35.5957L44.793 39.5859L45.8477 35.6309L48.6514 38.6191L47.5879 34.6641L51.499 35.8506L48.5986 32.9502L52.5889 32.0186L48.6338 30.9639L51.6221 28.1689L47.667 29.2236L48.8623 25.3125L45.9619 28.2129L45.0303 24.2227L43.9756 28.1777L41.1807 25.1895L42.2354 29.1445L38.3242 27.958L41.2246 30.8584L37.2344 31.7812L41.1895 32.8359L38.2012 35.6484L42.1562 34.5762L40.9697 38.4961Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_21549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrNauru);
export default __webpack_public_path__ + "static/media/nr Nauru.9c1d0627f447d00c9991f2ee36608c1a.svg";
export { ForwardRef as ReactComponent };